import { render, staticRenderFns } from "./CompanyLogin.vue?vue&type=template&id=64c7bcb9&scoped=true&"
import script from "./CompanyLogin.vue?vue&type=script&lang=js&"
export * from "./CompanyLogin.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLogin.vue?vue&type=style&index=0&id=64c7bcb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c7bcb9",
  null
  
)

export default component.exports